
import { join, replace } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { toShortDateString } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { int32ToString } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { map, defaultArg } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { tryFind } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export function fieldValueToString(t, fv) {
    switch (fv.tag) {
        case 1:
            return fv.fields[0];
        case 2:
            return replace((fv.fields[0] / 100).toString(), ".", ",");
        case 4:
            return toShortDateString(fv.fields[0]);
        case 5:
            if (fv.fields[0]) {
                return t("general.yes");
            }
            else {
                return t("general.no");
            }
        case 6:
            return fv.fields[0];
        case 7:
            return join(", ", fv.fields[0]);
        case 3:
            return int32ToString(fv.fields[0]);
        default:
            return "";
    }
}

export function tryGetFieldValueByName(t, fieldName, rv) {
    return defaultArg(map((f_1) => {
        const matchValue = f_1.NewValue;
        if (matchValue.tag === 0) {
            return "";
        }
        else {
            return fieldValueToString(t, matchValue);
        }
    }, tryFind((f) => (f.FieldName === fieldName), rv.Fields)), "");
}

export function hasValueChanged(t, fv) {
    return fieldValueToString(t, fv.OldValue) !== fieldValueToString(t, fv.NewValue);
}

